import { Workbox } from 'workbox-window';

export default function registerServiceWorker() {

  try {
    // if ('production' !== process.env.NODE_ENV) {
    //   return;
    // }
    // Check if the serviceWorker Object exists in the navigator object ( means if browser supports SW )
    if ("serviceWorker" in navigator) {
      // Register a service worker hosted at the root of the
      // site using the default scope.
      navigator.serviceWorker.register("/sw.js").then(
        (registration) => {
          console.log("Service worker registration succeeded:", registration);
        },
        (error) => {
          console.error(`Service worker registration failed: ${error}`);
        },
      );
    } else {
      console.error("Service workers are not supported.");
    }
  } catch (error) {
    console.log(error)
  }
}